import { SvgProps } from '../interface/interface';

//More Options Icon
export const MoreOptionsIcon = ({ className }: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="6"
    height="21"
    viewBox="0 0 6 21"
    fill="none"
    className={className}
  >
    <path
      d="M2.9839 7.2939C1.33449 7.2939 3.52859e-05 8.62836 3.52859e-05 10.2778C3.52859e-05 
      11.9272 1.33449 13.2616 2.9839 13.2616C4.63332 13.2616 5.96777 11.9272 5.96777 10.2778C5.96777 
      8.62836 4.63332 7.2939 2.9839 7.2939ZM5.96777 2.98387C5.96777 4.63329 4.63332 5.96774 2.9839 
      5.96774C1.33449 5.96774 3.52859e-05 4.63329 3.52859e-05 2.98387C3.52859e-05 1.33445 1.33449 
      0 2.9839 0C4.63332 0 5.96777 1.33445 5.96777 2.98387ZM5.96777 17.5717C5.96777 19.2211 4.63332 
      20.5555 2.9839 20.5555C1.33449 20.5555 3.52859e-05 19.2211 3.52859e-05 17.5717C3.52859e-05 
      15.9223 1.33449 14.5878 2.9839 14.5878C4.63332 14.5878 5.96777 15.9223 5.96777 17.5717Z"
      fill="#7D395D"
    />
  </svg>
);

//Consultation Icon
export const ConsultationIcon = ({ className }: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="31"
    viewBox="0 0 24 31"
    fill="none"
    className={className}
  >
    <path
      d="M0.0102936 30.3304C0.0903608 30.3304 0.157443 30.3391 0.220199 
      30.3282C0.540468 30.2763 0.862904 30.233 1.18101 30.1616C3.5787 
      29.6141 5.78812 28.6403 7.79846 27.2208C10.1247 25.5783 11.9057 
      23.4792 13.0548 20.8651C13.7819 19.2097 14.483 17.5456 15.1971 
      15.8837C15.2166 15.8382 15.2252 15.7906 15.2469 15.717C15.156 
      15.7582 15.0954 15.7863 15.0348 15.8166C13.6628 16.4744 12.2909 
      17.1366 10.9146 17.7901C8.48444 18.9457 6.55417 20.6661 5.11945 
      22.9426C5.09349 22.9837 5.06102 23.0226 5.0026 23.1027C5.0026 
      22.9707 5.0026 22.8906 5.0026 22.8106C5.0026 19.2876 5.0026 
      15.7646 5.0026 12.2417C5.0026 11.6531 5.01991 11.0645 5.08699 
      10.478C5.17355 9.72281 5.32287 8.98057 5.58471 8.26429C6.22092 
      6.52661 7.38081 5.31262 9.14878 4.71103C9.87155 4.46434 10.6181 
      4.34748 11.3798 4.30637C12.4424 4.24794 13.4919 4.31935 14.5176 
      4.61365C16.2813 5.11786 17.532 6.21283 18.2613 7.89857C18.5751 
      8.62351 18.7612 9.38523 18.8737 10.1664C18.9754 10.8719 19.0014 
      11.5817 19.0014 12.2936C18.9992 16.6432 18.9971 20.9928 19.0036 
      25.3403C19.0057 26.7122 19.4948 27.8959 20.4599 28.8697C21.3493 
      29.7678 22.44 30.2438 23.6972 30.3347C23.7946 30.3412 23.8941 
      30.3347 24.0002 30.3347C24.0002 30.22 24.0002 30.1335 24.0002 
      30.0447C24.0002 24.1241 24.0002 18.2034 24.0002 12.2828C24.0002 
      11.348 23.9591 10.4153 23.8336 9.48694C23.6907 8.41577 23.4484 
      7.37056 23.061 6.35999C22.1824 4.08131 20.6828 2.36311 18.4777 
      1.28545C16.9348 0.532386 15.2858 0.188315 13.5849 0.0584758C12.5852 
      -0.0172636 11.5833 -0.0194286 10.5813 0.0519828C9.47771 0.129886 
      8.39139 0.309494 7.33104 0.634091C5.99586 1.04308 4.77105 1.66198 
      3.69988 2.56653C2.37336 3.68747 1.46016 5.08973 0.865066 
      6.71055C0.261315 8.35734 0.00813065 10.0669 0.00596667 
      11.8111C-0.00268925 17.9156 0.00380057 24.0181 0.00380057 
      30.1227C0.00163659 30.1941 0.00812959 30.259 0.0102936 30.3304Z"
      fill="white"
    />
    <path
      d="M0.0100689 30.3305C0.00574098 30.2591 0.00141513 30.1941 0.00141513 30.1271C0.00141513 24.0225 -0.002916 17.92 0.00357595 11.8154C0.00573993 10.0691 0.258925 8.35957 0.862675 6.71494C1.45561 5.09412 2.37097 3.69186 3.69749 2.57092C4.76866 1.66638 5.99347 1.04748 7.32865 0.638486C8.389 0.313889 9.47532 0.134281 10.5789 0.0563773C11.5809 -0.0150341 12.5828 -0.012869 13.5826 0.0628703C15.2834 0.192709 16.9324 0.536781 18.4753 1.28985C20.6804 2.36751 22.1801 4.08571 23.0586 6.36438C23.4481 7.37496 23.6883 8.42016 23.8312 9.49133C23.9545 10.4197 23.9978 11.3524 23.9978 12.2872C23.9956 18.2078 23.9978 24.1285 23.9978 30.0491C23.9978 30.1379 23.9978 30.2244 23.9978 30.3391C23.8918 30.3391 23.7922 30.3456 23.6948 30.3391C22.4354 30.2482 21.3469 29.7722 20.4575 28.8741C19.4924 27.9003 19.0033 26.7166 19.0012 25.3447C18.9947 20.9951 18.999 16.6455 18.999 12.298C18.999 11.5861 18.973 10.8763 18.8713 10.1708C18.7588 9.38962 18.5727 8.63007 18.2589 7.90297C17.5296 6.21723 16.2789 5.12442 14.5152 4.61805C13.4895 4.32375 12.4378 4.25234 11.3775 4.31076C10.6179 4.35188 9.86916 4.4709 9.14639 4.71543C7.37626 5.31701 6.21637 6.53101 5.58232 8.26868C5.32048 8.98496 5.17116 9.72504 5.0846 10.4824C5.01752 11.0689 5.00021 11.6575 5.00021 12.2461C5.00237 15.769 5.00021 19.292 5.00021 22.815C5.00021 22.895 5.00021 22.9751 5.00021 23.1071C5.05864 23.027 5.0911 22.9881 5.11706 22.947C6.55178 20.6705 8.48205 18.9523 10.9122 17.7945C12.2863 17.141 13.6583 16.4788 15.0324 15.821C15.093 15.7928 15.1536 15.7647 15.2445 15.7214C15.2229 15.795 15.2142 15.8448 15.1947 15.8881C14.4828 17.5478 13.7795 19.2141 13.0524 20.8695C11.9033 23.4836 10.1224 25.5827 7.79607 27.2252C5.78573 28.6447 3.57631 29.6185 1.17862 30.166C0.862677 30.2374 0.540246 30.2807 0.217813 30.3326C0.157222 30.3391 0.0901362 30.3305 0.0100689 30.3305Z"
      fill="#124833"
    />
  </svg>
);

//Mail Icon
export const MailIcon = ({ className }: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    className={className}
  >
    <path d="M2.58466 6.85276L13.6794 17.9475C14.3659 18.634 15.4522 18.6769 16.1886 18.0762L16.331 17.9475L27.4175 6.86101C27.4534 6.99704 27.4781 7.1376 27.4906 7.28166L27.5 7.50024V22.5002C27.5 23.8182 26.4802 24.898 25.1866 24.9934L25 25.0002H5C3.68205 25.0002 2.60229 23.9804 2.50686 22.6868L2.5 22.5002V7.50024C2.5 7.35096 2.51308 7.20473 2.53817 7.06265L2.58466 6.85276ZM25 5.00024C25.1513 5.00024 25.2995 5.01368 25.4434 5.03943L25.6559 5.08716L15.0052 15.7377L4.35239 5.08494C4.49009 5.04811 4.63247 5.02274 4.77846 5.00993L5 5.00024H25Z" />
  </svg>
);

//All medications icon
export const AllMedicationsIcon = ({ className }: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="31"
    height="41"
    viewBox="0 0 31 41"
    fill="none"
    className={className}
  >
    <path
      d="M18.0878 10.7073V0H1.93798C0.864016 0 0 0.842416 0 1.88953V38.4205C0 39.4676 0.864016 40.31 1.93798 40.31H29.0697C30.1437 40.31 31.0077 39.4676 31.0077 38.4205V12.5969H20.0258C18.9599 12.5969 18.0878 11.7466 18.0878 10.7073ZM23.6216 24.8379L24.5348 25.7283C25.0395 26.2204 25.0395 27.0179 24.5348 27.51L22.1204 29.864L24.5478 32.2307C25.0524 32.7227 25.0524 33.5203 24.5478 34.0124L23.6345 34.9028C23.1298 35.3949 22.3118 35.3949 21.8071 34.9028L19.3798 32.5354L16.9525 34.902C16.4478 35.3941 15.6298 35.3941 15.1251 34.902L14.2119 34.0116C13.7072 33.5195 13.7072 32.722 14.2119 32.2299L16.6392 29.8633L11.8491 25.1938H10.3359V28.9728C10.3359 29.6688 9.75773 30.2325 9.04391 30.2325H7.75192C7.0381 30.2325 6.45994 29.6688 6.45994 28.9728V16.3759C6.45994 15.68 7.0381 15.1163 7.75192 15.1163H14.2119C17.0663 15.1163 19.3798 17.3719 19.3798 20.155C19.3798 22.0619 18.28 23.7018 16.6779 24.5576L19.3798 27.1919L21.7942 24.8379C22.2989 24.3458 23.1169 24.3458 23.6216 24.8379ZM14.2119 21.4147H10.3359V18.8953H14.2119C14.9241 18.8953 15.5038 19.4606 15.5038 20.155C15.5038 20.8494 14.9241 21.4147 14.2119 21.4147ZM31.0077 9.59724V10.0775H20.6718V0H21.1644C21.6812 0 22.1737 0.196826 22.5371 0.551113L30.4424 8.2667C30.8058 8.62099 31.0077 9.10124 31.0077 9.59724Z"
      fill="#BCC4E1"
    />
  </svg>
);
export const MedicationsBlueIcon = ({ className }: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="23"
    viewBox="0 0 31 41"
    fill="none"
    className={className}
  >
    <path
      d="M18.0878 10.7073V0H1.93798C0.864016 0 0 0.842416 0 1.88953V38.4205C0 39.4676 0.864016 40.31 1.93798 40.31H29.0697C30.1437 40.31 31.0077 39.4676 31.0077 38.4205V12.5969H20.0258C18.9599 12.5969 18.0878 11.7466 18.0878 10.7073ZM23.6216 24.8379L24.5348 25.7283C25.0395 26.2204 25.0395 27.0179 24.5348 27.51L22.1204 29.864L24.5478 32.2307C25.0524 32.7227 25.0524 33.5203 24.5478 34.0124L23.6345 34.9028C23.1298 35.3949 22.3118 35.3949 21.8071 34.9028L19.3798 32.5354L16.9525 34.902C16.4478 35.3941 15.6298 35.3941 15.1251 34.902L14.2119 34.0116C13.7072 33.5195 13.7072 32.722 14.2119 32.2299L16.6392 29.8633L11.8491 25.1938H10.3359V28.9728C10.3359 29.6688 9.75773 30.2325 9.04391 30.2325H7.75192C7.0381 30.2325 6.45994 29.6688 6.45994 28.9728V16.3759C6.45994 15.68 7.0381 15.1163 7.75192 15.1163H14.2119C17.0663 15.1163 19.3798 17.3719 19.3798 20.155C19.3798 22.0619 18.28 23.7018 16.6779 24.5576L19.3798 27.1919L21.7942 24.8379C22.2989 24.3458 23.1169 24.3458 23.6216 24.8379ZM14.2119 21.4147H10.3359V18.8953H14.2119C14.9241 18.8953 15.5038 19.4606 15.5038 20.155C15.5038 20.8494 14.9241 21.4147 14.2119 21.4147ZM31.0077 9.59724V10.0775H20.6718V0H21.1644C21.6812 0 22.1737 0.196826 22.5371 0.551113L30.4424 8.2667C30.8058 8.62099 31.0077 9.10124 31.0077 9.59724Z"
      fill="#1f3d7b"
    />
  </svg>
);

//order again icon
export const OrderAgainIcon = ({ className }: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="20"
    viewBox="0 0 22 20"
    fill="none"
    className={className}
  >
    <path
      d="M19.2774 12.4444H8.08088L8.33086 13.6666H18.5829C19.1712 13.6666 19.6072 14.2128 19.4768 14.7864L19.2661 15.7136C19.98 16.0602 20.4722 16.792 20.4722 17.6388C20.4722 18.8306 19.4975 19.7947 18.3019 19.7775C17.1628 19.7611 16.226 18.8367 16.1952 17.6979C16.1784 17.0758 16.4277 16.512 16.837 16.111H8.82964C9.22598 16.4993 9.47222 17.0402 9.47222 17.6388C9.47222 18.8539 8.459 19.8324 7.23136 19.7754C6.14129 19.7247 5.25475 18.844 5.19746 17.7542C5.15323 16.9126 5.59606 16.1709 6.26886 15.7839L3.58581 2.66661H0.916667C0.410399 2.66661 0 2.25621 0 1.74995V1.13883C0 0.632567 0.410399 0.222168 0.916667 0.222168H4.83271C5.26816 0.222168 5.6435 0.528526 5.73077 0.955119L6.08086 2.66661H21.083C21.6712 2.66661 22.1072 3.21283 21.9768 3.78644L20.1713 11.7309C20.0764 12.1482 19.7054 12.4444 19.2774 12.4444ZM15.5833 6.63883H13.75V5.11106C13.75 4.77353 13.4764 4.49995 13.1389 4.49995H12.5278C12.1903 4.49995 11.9167 4.77353 11.9167 5.11106V6.63883H10.0833C9.74581 6.63883 9.47222 6.91242 9.47222 7.24995V7.86106C9.47222 8.19858 9.74581 8.47217 10.0833 8.47217H11.9167V9.99995C11.9167 10.3375 12.1903 10.6111 12.5278 10.6111H13.1389C13.4764 10.6111 13.75 10.3375 13.75 9.99995V8.47217H15.5833C15.9209 8.47217 16.1944 8.19858 16.1944 7.86106V7.24995C16.1944 6.91242 15.9209 6.63883 15.5833 6.63883Z"
      fill="#1F3D7B"
    />
  </svg>
);

//download invoice icon
export const DownloadInvoiceIcon = ({ className }: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="28"
    viewBox="0 0 24 28"
    fill="none"
    className={className}
  >
    <path
      d="M17.2814 10.3515H15.6252V4.60061C15.6252 3.96802 15.1564 3.45044 14.5835 3.45044H10.4168C9.84391 3.45044 9.37516 3.96802 9.37516 4.60061V10.3515H7.71891C6.79183 10.3515 6.32308 11.5937 6.97933 12.3183L11.7606 17.5976C12.1668 18.0461 12.8231 18.0461 13.2293 17.5976L18.0106 12.3183C18.6668 11.5937 18.2085 10.3515 17.2814 10.3515ZM5.2085 21.8532C5.2085 22.4858 5.67725 23.0034 6.25016 23.0034H18.7502C19.3231 23.0034 19.7918 22.4858 19.7918 21.8532C19.7918 21.2206 19.3231 20.703 18.7502 20.703H6.25016C5.67725 20.703 5.2085 21.2206 5.2085 21.8532Z"
      fill="#1F3D7B"
    />
  </svg>
);

//view order icon
export const ViewOrderIcon = ({ className }: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="26"
    viewBox="0 0 21 26"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.851119 1.45537C2.59806e-07 2.30647 0 3.67632 0 6.41601V19.4925C0 22.2321 2.59806e-07 23.602 0.851119 24.4531C1.70222 25.3042 3.07207 25.3042 5.81176 25.3042H14.5294C17.2691 25.3042 18.6389 25.3042 19.49 24.4531C20.3412 23.602 20.3412 22.2321 20.3412 19.4925V6.41601C20.3412 3.67632 20.3412 2.30647 19.49 1.45537C18.6389 0.604248 17.2691 0.604248 14.5294 0.604248H5.81176C3.07207 0.604248 1.70222 0.604248 0.851119 1.45537ZM5.81176 6.41601C5.00933 6.41601 4.35882 7.06652 4.35882 7.86895C4.35882 8.67138 5.00933 9.32189 5.81176 9.32189H14.5294C15.3319 9.32189 15.9824 8.67138 15.9824 7.86895C15.9824 7.06652 15.3319 6.41601 14.5294 6.41601H5.81176ZM5.81176 12.2278C5.00933 12.2278 4.35882 12.8783 4.35882 13.6807C4.35882 14.4832 5.00933 15.1337 5.81176 15.1337H14.5294C15.3319 15.1337 15.9824 14.4832 15.9824 13.6807C15.9824 12.8783 15.3319 12.2278 14.5294 12.2278H5.81176ZM5.81176 18.0395C5.00933 18.0395 4.35882 18.69 4.35882 19.4925C4.35882 20.2949 5.00933 20.9454 5.81176 20.9454H11.6235C12.426 20.9454 13.0765 20.2949 13.0765 19.4925C13.0765 18.69 12.426 18.0395 11.6235 18.0395H5.81176Z"
      fill="#1F3D7B"
    />
  </svg>
);

//down caret icon
export const DownCaretIcon = ({ className }: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="15"
    viewBox="0 0 24 15"
    fill="none"
    className={className}
  >
    <g filter="url(#filter0_d_1522_2825)">
      <path
        d="M3.30479 1H20.0869C21.2479 1 21.8284 2.40231 21.0065 3.22413L12.6188 11.6184C12.11 12.1272 11.2817 12.1272 10.7729 11.6184L2.38513 3.22413C1.56331 2.40231 2.14381 1 3.30479 1Z"
        fill="#1F3D7B"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_1522_2825"
        x="0"
        y="0"
        width="23.3917"
        height="15"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1522_2825"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1522_2825"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

// close icon
export const CloseIcon = ({
  onClick,
  className,
}: { onClick: () => void } & SvgProps) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    aria-label="closeIcon"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
    className={className}
  >
    <path
      d="M13.1014 9.5L18.5029 4.09849C19.1657 3.43565 19.1657 2.36097 18.5029 1.69759L17.3024 0.497131C16.6396 -0.16571 15.5649 -0.16571 14.9015 0.497131L9.5 5.89864L4.09849 0.497131C3.43565 -0.16571 2.36097 -0.16571 1.69759 0.497131L0.497131 1.69759C-0.16571 2.36043 -0.16571 3.43511 0.497131 4.09849L5.89864 9.5L0.497131 14.9015C-0.16571 15.5643 -0.16571 16.639 0.497131 17.3024L1.69759 18.5029C2.36043 19.1657 3.43565 19.1657 4.09849 18.5029L9.5 13.1014L14.9015 18.5029C15.5643 19.1657 16.6396 19.1657 17.3024 18.5029L18.5029 17.3024C19.1657 16.6396 19.1657 15.5649 18.5029 14.9015L13.1014 9.5Z"
      fill=""
    />
  </svg>
);

export const CloseIconWhiteFill = ({
  onClick,
  className,
}: { onClick: () => void } & SvgProps) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
    className={className}
  >
    <path
      d="M13.1014 9.5L18.5029 4.09849C19.1657 3.43565 19.1657 2.36097 18.5029 1.69759L17.3024 0.497131C16.6396 -0.16571 15.5649 -0.16571 14.9015 0.497131L9.5 5.89864L4.09849 0.497131C3.43565 -0.16571 2.36097 -0.16571 1.69759 0.497131L0.497131 1.69759C-0.16571 2.36043 -0.16571 3.43511 0.497131 4.09849L5.89864 9.5L0.497131 14.9015C-0.16571 15.5643 -0.16571 16.639 0.497131 17.3024L1.69759 18.5029C2.36043 19.1657 3.43565 19.1657 4.09849 18.5029L9.5 13.1014L14.9015 18.5029C15.5643 19.1657 16.6396 19.1657 17.3024 18.5029L18.5029 17.3024C19.1657 16.6396 19.1657 15.5649 18.5029 14.9015L13.1014 9.5Z"
      fill="#ffffff"
    />
  </svg>
);

export const PlusIcon = ({ className }: SvgProps) => (
  <svg
    width="26"
    height="25"
    viewBox="0 0 26 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M21.6667 0H4.33333C3.18406 0 2.08186 0.438987 1.2692 1.22039C0.456546 2.00179 0 3.0616 0 4.16667V20.8333C0 21.9384 0.456546 22.9982 1.2692 23.7796C2.08186 24.561 3.18406 25 4.33333 25H21.6667C22.8159 25 23.9181 24.561 24.7308 23.7796C25.5435 22.9982 26 21.9384 26 20.8333V4.16667C26 3.0616 25.5435 2.00179 24.7308 1.22039C23.9181 0.438987 22.8159 0 21.6667 0ZM17.3333 13.8889H14.4444V16.6667C14.4444 17.035 14.2923 17.3883 14.0214 17.6488C13.7505 17.9092 13.3831 18.0556 13 18.0556C12.6169 18.0556 12.2495 17.9092 11.9786 17.6488C11.7077 17.3883 11.5556 17.035 11.5556 16.6667V13.8889H8.66667C8.28358 13.8889 7.91618 13.7426 7.64529 13.4821C7.3744 13.2216 7.22222 12.8684 7.22222 12.5C7.22222 12.1316 7.3744 11.7784 7.64529 11.5179C7.91618 11.2574 8.28358 11.1111 8.66667 11.1111H11.5556V8.33333C11.5556 7.96498 11.7077 7.61171 11.9786 7.35124C12.2495 7.09077 12.6169 6.94444 13 6.94444C13.3831 6.94444 13.7505 7.09077 14.0214 7.35124C14.2923 7.61171 14.4444 7.96498 14.4444 8.33333V11.1111H17.3333C17.7164 11.1111 18.0838 11.2574 18.3547 11.5179C18.6256 11.7784 18.7778 12.1316 18.7778 12.5C18.7778 12.8684 18.6256 13.2216 18.3547 13.4821C18.0838 13.7426 17.7164 13.8889 17.3333 13.8889Z"
      fill="#1F3D7B"
    />
  </svg>
);

export const MinusIcon = ({ className }: SvgProps) => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.72727 0C3.47352 0 2.27112 0.498051 1.38459 1.38459C0.498051 2.27112 0 3.47352 0 4.72727V21.2727C0 22.5265 0.498051 23.7289 1.38459 24.6154C2.27112 25.5019 3.47352 26 4.72727 26H21.2727C22.5265 26 23.7289 25.5019 24.6154 24.6154C25.5019 23.7289 26 22.5265 26 21.2727V4.72727C26 3.47352 25.5019 2.27112 24.6154 1.38459C23.7289 0.498051 22.5265 0 21.2727 0H4.72727ZM5.90909 11.8182C5.59565 11.8182 5.29505 11.9427 5.07342 12.1643C4.85179 12.386 4.72727 12.6866 4.72727 13C4.72727 13.3134 4.85179 13.614 5.07342 13.8357C5.29505 14.0573 5.59565 14.1818 5.90909 14.1818H20.0909C20.4043 14.1818 20.7049 14.0573 20.9266 13.8357C21.1482 13.614 21.2727 13.3134 21.2727 13C21.2727 12.6866 21.1482 12.386 20.9266 12.1643C20.7049 11.9427 20.4043 11.8182 20.0909 11.8182H5.90909Z"
      fill="#1F3D7B"
    />
  </svg>
);
export const DropdownIcon = () => (
  <svg
    className="ml-4 h-4 2.5xl:h-5"
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23 2.46429V20.5357C23 21.8962 21.8962 23 20.5357 23H2.46429C1.10379 23 0 21.8962 0 20.5357V2.46429C0 1.10379 1.10379 0 2.46429 0H20.5357C21.8962 0 23 1.10379 23 2.46429ZM4.74888 9.67746L11.0636 15.9922C11.3049 16.2335 11.6951 16.2335 11.9364 15.9922L18.2511 9.67746C18.6413 9.28728 18.3641 8.625 17.8147 8.625H5.18527C4.63594 8.625 4.35871 9.28728 4.74888 9.67746Z"
      fill="#F3F6FB"
    />
  </svg>
);

export const OrderSummaryIcon = ({ className }: SvgProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 142 124"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M88.425 0V35.37C17.685 35.37 0 71.6242 0 123.795C9.1962 88.7787 35.37 70.74 70.74 70.74H88.425V106.11L141.48 50.2254L88.425 0Z"
      fill="#173d7b"
    />
  </svg>
);
export const TokenIcon = ({ className, height, width }: SvgProps) => (
  <svg
    width={width?.toString() ?? '21'}
    height={height?.toString() ?? '22'}
    viewBox="0 0 21 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M18.6154 2.85477C15.5185 -0.23164 10.4965 -0.23164 7.42056 2.85477C5.25484 4.99957 4.60617 8.08598 5.44316 10.8062L0.525828 15.7235C0.180568 16.0793 -0.0600671 16.7802 0.0131698 17.2824L0.327042 19.5632C0.442129 20.3165 1.14311 21.028 1.8964 21.1326L4.17721 21.4465C4.67941 21.5197 5.38039 21.2895 5.73611 20.9234L6.59403 20.0654C6.80328 19.8666 6.80328 19.5319 6.59403 19.3226L4.56432 17.2929C4.26091 16.9895 4.26091 16.4873 4.56432 16.1839C4.86773 15.8805 5.36993 15.8805 5.67334 16.1839L7.71351 18.224C7.91229 18.4228 8.24709 18.4228 8.4459 18.224L10.6639 16.0165C13.3737 16.8639 16.4601 16.2048 18.6154 14.06C21.7018 10.9736 21.7018 5.94118 18.6154 2.85477ZM13.0807 10.9945C11.6369 10.9945 10.4651 9.82273 10.4651 8.37893C10.4651 6.93511 11.6369 5.76332 13.0807 5.76332C14.5246 5.76332 15.6964 6.93511 15.6964 8.37893C15.6964 9.82273 14.5246 10.9945 13.0807 10.9945Z"
      fill="#1F3D7B"
    />
  </svg>
);
export const NotesIcon = () => (
  <svg
    width="24"
    height="26"
    viewBox="0 0 24 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.8927 0C11.4097 0.000455135 11.9054 0.2062 12.2707 0.572L17.6293 5.928C17.8105 6.10932 17.9542 6.32458 18.0521 6.56148C18.15 6.79838 18.2003 7.05226 18.2 7.3086V13C16.1313 13 14.1474 13.8218 12.6846 15.2846C11.2218 16.7474 10.4 18.7313 10.4 20.8V26H1.95C1.43283 26 0.936838 25.7946 0.571142 25.4289C0.205446 25.0632 0 24.5672 0 24.05V1.95C0 1.43283 0.205446 0.936838 0.571142 0.571142C0.936838 0.205446 1.43283 0 1.95 0L10.8927 0ZM3.9 6.5H14.3V9.1H3.9V6.5ZM10.4 11.7H3.9V14.3H10.4V11.7ZM3.9 16.9H7.8V19.5H3.9V16.9ZM23.0191 19.8809C22.7754 19.6371 22.4448 19.5001 22.1 19.5H19.5V16.9C19.5 16.5552 19.363 16.2246 19.1192 15.9808C18.8754 15.737 18.5448 15.6 18.2 15.6C17.8552 15.6 17.5246 15.737 17.2808 15.9808C17.037 16.2246 16.9 16.5552 16.9 16.9V19.5H14.3C13.9552 19.5 13.6246 19.637 13.3808 19.8808C13.137 20.1246 13 20.4552 13 20.8C13 21.1448 13.137 21.4754 13.3808 21.7192C13.6246 21.963 13.9552 22.1 14.3 22.1H16.9V24.7C16.9 25.0448 17.037 25.3754 17.2808 25.6192C17.5246 25.863 17.8552 26 18.2 26C18.5448 26 18.8754 25.863 19.1192 25.6192C19.363 25.3754 19.5 25.0448 19.5 24.7V22.1H22.1C22.3571 22.0999 22.6084 22.0237 22.8221 21.8808C23.0358 21.738 23.2024 21.535 23.3008 21.2974C23.3992 21.0599 23.4249 20.7986 23.3748 20.5465C23.3246 20.2943 23.2009 20.0627 23.0191 19.8809Z"
      fill="#F3F6FB"
    />
  </svg>
);
export const NotesIconBlue = () => (
  <svg
    width="24"
    height="26"
    viewBox="0 0 24 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.8927 0C11.4097 0.000455135 11.9054 0.2062 12.2707 0.572L17.6293 5.928C17.8105 6.10932 17.9542 6.32458 18.0521 6.56148C18.15 6.79838 18.2003 7.05226 18.2 7.3086V13C16.1313 13 14.1474 13.8218 12.6846 15.2846C11.2218 16.7474 10.4 18.7313 10.4 20.8V26H1.95C1.43283 26 0.936838 25.7946 0.571142 25.4289C0.205446 25.0632 0 24.5672 0 24.05V1.95C0 1.43283 0.205446 0.936838 0.571142 0.571142C0.936838 0.205446 1.43283 0 1.95 0L10.8927 0ZM3.9 6.5H14.3V9.1H3.9V6.5ZM10.4 11.7H3.9V14.3H10.4V11.7ZM3.9 16.9H7.8V19.5H3.9V16.9ZM23.0191 19.8809C22.7754 19.6371 22.4448 19.5001 22.1 19.5H19.5V16.9C19.5 16.5552 19.363 16.2246 19.1192 15.9808C18.8754 15.737 18.5448 15.6 18.2 15.6C17.8552 15.6 17.5246 15.737 17.2808 15.9808C17.037 16.2246 16.9 16.5552 16.9 16.9V19.5H14.3C13.9552 19.5 13.6246 19.637 13.3808 19.8808C13.137 20.1246 13 20.4552 13 20.8C13 21.1448 13.137 21.4754 13.3808 21.7192C13.6246 21.963 13.9552 22.1 14.3 22.1H16.9V24.7C16.9 25.0448 17.037 25.3754 17.2808 25.6192C17.5246 25.863 17.8552 26 18.2 26C18.5448 26 18.8754 25.863 19.1192 25.6192C19.363 25.3754 19.5 25.0448 19.5 24.7V22.1H22.1C22.3571 22.0999 22.6084 22.0237 22.8221 21.8808C23.0358 21.738 23.2024 21.535 23.3008 21.2974C23.3992 21.0599 23.4249 20.7986 23.3748 20.5465C23.3246 20.2943 23.2009 20.0627 23.0191 19.8809Z"
      fill="#1f3d7b"
    />
  </svg>
);
export const UserHeartIcon = () => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.9188 17H14.5563C14.5563 17 14.5563 16.7875 14.5563 16.3625L13.9188 17Z"
      fill="#EEFBF4"
    />
    <path
      d="M7.96875 14.7687C7.225 14.025 6.90625 12.8563 7.11875 11.7938C7.33125 10.7313 7.96875 9.88125 8.925 9.5625C8.925 9.45625 8.81875 9.35 8.81875 9.35C8.81875 8.7125 9.66875 8.925 10.3063 7.75625C10.3063 7.75625 13.175 0 7.225 0C1.38125 0 4.25 7.75625 4.25 7.75625C4.8875 8.81875 5.7375 8.60625 5.7375 9.35C5.7375 10.0938 4.99375 10.0938 4.25 10.2C3.08125 10.3063 2.01875 10.0938 0.95625 12.0063C0.31875 13.175 0 17 0 17H10.2L7.96875 14.7687Z"
      fill="#EEFBF4"
    />
    <path
      d="M14.6625 10.7313C14.45 10.625 14.1313 10.625 13.9188 10.625C13.175 10.625 12.5375 11.2625 12.1125 11.7938C11.6875 11.2625 11.05 10.625 10.3063 10.625C9.98751 10.625 9.77501 10.625 9.56251 10.7313C8.28751 11.1563 8.07501 12.8563 9.03126 13.8125L12.2188 16.8937L15.4063 13.8125C16.2563 12.8563 15.9375 11.1563 14.6625 10.7313Z"
      fill="#EEFBF4"
    />
  </svg>
);
export const EditPatientIcon = () => (
  <svg
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.25021 7.89983C6.9073 7.89983 8.25032 6.2995 8.25032 4.32492C8.25032 2.35033 6.9073 0.75 5.25021 0.75C3.59311 0.75 2.25009 2.35033 2.25009 4.32492C2.25009 6.2995 3.59311 7.89983 5.25021 7.89983ZM7.35029 8.79356H6.95887C6.43853 9.07843 5.8596 9.24042 5.25021 9.24042C4.64081 9.24042 4.06422 9.07843 3.54154 8.79356H3.15012C1.41099 8.79356 0 10.4749 0 12.5472V13.7091C0 14.4492 0.503926 15.0497 1.12504 15.0497H7.56826C7.51201 14.8597 7.48857 14.6587 7.50732 14.4548L7.66671 12.7539L7.69483 12.4439L7.88 12.2232L9.69179 10.0643C9.11754 9.2907 8.28548 8.79356 7.35029 8.79356ZM8.41205 12.8516L8.25267 14.5553C8.22688 14.8402 8.42845 15.0804 8.66518 15.0469L10.0926 14.857L13.3247 11.0055L11.6442 9.00303L8.41205 12.8516ZM14.8365 8.26011L13.9482 7.2016C13.7302 6.94186 13.374 6.94186 13.156 7.2016L12.27 8.25732L12.1739 8.37183L13.8568 10.3743L14.8365 9.20691C15.0545 8.94438 15.0545 8.52265 14.8365 8.26011Z"
      fill="#A74C7C"
    />
  </svg>
);
export const PrescriptionIcon = () => (
  <svg
    width="16"
    height="22"
    viewBox="0 0 16 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.7094 0.539978H0.980625C0.441281 0.539978 0 0.981259 0 1.5206V3.48185C0 4.0212 0.441281 4.46248 0.980625 4.46248H14.7094C15.2487 4.46248 15.69 4.0212 15.69 3.48185V1.5206C15.69 0.981259 15.2487 0.539978 14.7094 0.539978ZM1.3075 20.1525C1.3075 20.8716 1.89587 21.46 2.615 21.46H13.075C13.7941 21.46 14.3825 20.8716 14.3825 20.1525V5.76998H1.3075V20.1525ZM3.9225 12.6344C3.9225 12.4546 4.06959 12.3075 4.24937 12.3075H6.5375V10.0194C6.5375 9.83957 6.68459 9.69248 6.86438 9.69248H8.82563C9.00541 9.69248 9.1525 9.83957 9.1525 10.0194V12.3075H11.4406C11.6204 12.3075 11.7675 12.4546 11.7675 12.6344V14.5956C11.7675 14.7754 11.6204 14.9225 11.4406 14.9225H9.1525V17.2106C9.1525 17.3904 9.00541 17.5375 8.82563 17.5375H6.86438C6.68459 17.5375 6.5375 17.3904 6.5375 17.2106V14.9225H4.24937C4.06959 14.9225 3.9225 14.7754 3.9225 14.5956V12.6344Z"
      fill="white"
    />
  </svg>
);
export const EyeIcon = ({ className }: SvgProps) => (
  <svg
    width="21"
    height="15"
    viewBox="0 0 21 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M20.3043 7.27688C19.5325 5.28033 18.1925 3.55372 16.4501 2.31043C14.7076 1.06715 12.639 0.361688 10.5 0.28125C8.36093 0.361688 6.29235 1.06715 4.54988 2.31043C2.80741 3.55372 1.46745 5.28033 0.69559 7.27688C0.643462 7.42106 0.643462 7.57894 0.69559 7.72312C1.46745 9.71967 2.80741 11.4463 4.54988 12.6896C6.29235 13.9329 8.36093 14.6383 10.5 14.7188C12.639 14.6383 14.7076 13.9329 16.4501 12.6896C18.1925 11.4463 19.5325 9.71967 20.3043 7.72312C20.3565 7.57894 20.3565 7.42106 20.3043 7.27688ZM10.5 11.7656C9.65631 11.7656 8.83159 11.5155 8.13011 11.0467C7.42863 10.578 6.8819 9.91183 6.55904 9.13238C6.23619 8.35294 6.15171 7.49527 6.3163 6.66782C6.48089 5.84037 6.88715 5.08031 7.48371 4.48375C8.08027 3.88719 8.84033 3.48093 9.66778 3.31634C10.4952 3.15175 11.3529 3.23622 12.1323 3.55908C12.9118 3.88193 13.578 4.42867 14.0467 5.13015C14.5154 5.83162 14.7656 6.65634 14.7656 7.5C14.7639 8.63078 14.3139 9.71475 13.5143 10.5143C12.7147 11.3139 11.6307 11.7639 10.5 11.7656Z"
      fill="#A74C7C"
    />
  </svg>
);

export const MoreOptionComponentIcon = () => (
  <svg
    width="6"
    height="21"
    viewBox="0 0 6 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.9839 7.2939C1.33449 7.2939 3.52859e-05 8.62836 3.52859e-05 10.2778C3.52859e-05 11.9272 1.33449 13.2616 2.9839 13.2616C4.63332 13.2616 5.96777 11.9272 5.96777 10.2778C5.96777 8.62836 4.63332 7.2939 2.9839 7.2939ZM5.96777 2.98387C5.96777 4.63329 4.63332 5.96774 2.9839 5.96774C1.33449 5.96774 3.52859e-05 4.63329 3.52859e-05 2.98387C3.52859e-05 1.33445 1.33449 0 2.9839 0C4.63332 0 5.96777 1.33445 5.96777 2.98387ZM5.96777 17.5717C5.96777 19.2211 4.63332 20.5555 2.9839 20.5555C1.33449 20.5555 3.52859e-05 19.2211 3.52859e-05 17.5717C3.52859e-05 15.9223 1.33449 14.5878 2.9839 14.5878C4.63332 14.5878 5.96777 15.9223 5.96777 17.5717Z"
      fill="#D15F9B"
    />
  </svg>
);

export const CancelScriptIcon = ({ className }: SvgProps) => (
  <svg
    width="18"
    height="20"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M13.666 3.01163L11.9536 4.72408C11.7434 4.93423 11.7434 5.27494 11.9536 5.48525L12.3342 5.86583C12.5443 6.07597 12.885 6.07597 13.0953 5.86583L14.8078 4.15338L16.5202 5.86583C16.7304 6.07597 17.0711 6.07597 17.2814 5.86583L17.662 5.48525C17.8721 5.27511 17.8721 4.9344 17.662 4.72408L15.9495 3.01163L17.662 1.29918C17.8721 1.08904 17.8721 0.74833 17.662 0.538017L17.2814 0.157434C17.0712 -0.0527081 16.7304 -0.0527081 16.5202 0.157434L14.8078 1.86988L13.0953 0.157434C12.8852 -0.0527081 12.5443 -0.0527081 12.3342 0.157434L11.9536 0.538017C11.7434 0.748158 11.7434 1.08887 11.9536 1.29918L13.666 3.01163Z"
      fill="#1F3D7B"
    />
    <path
      d="M9.44752 6.02344H0.629835C0.283426 6.02344 0 6.30686 0 6.65327V7.91294C0 8.25935 0.283426 8.54278 0.629835 8.54278H9.44752C9.79393 8.54278 10.0774 8.25935 10.0774 7.91294V6.65327C10.0774 6.30686 9.79393 6.02344 9.44752 6.02344ZM0.83978 18.6201C0.83978 19.082 1.21768 19.4599 1.67956 19.4599H8.3978C8.85968 19.4599 9.23758 19.082 9.23758 18.6201V9.38256H0.83978V18.6201ZM2.51934 13.7914C2.51934 13.6759 2.61381 13.5815 2.72928 13.5815H4.1989V12.1118C4.1989 11.9964 4.29337 11.9019 4.40884 11.9019H5.66851C5.78398 11.9019 5.87846 11.9964 5.87846 12.1118V13.5815H7.34807C7.46354 13.5815 7.55802 13.6759 7.55802 13.7914V15.0511C7.55802 15.1665 7.46354 15.261 7.34807 15.261H5.87846V16.7306C5.87846 16.8461 5.78398 16.9406 5.66851 16.9406H4.40884C4.29337 16.9406 4.1989 16.8461 4.1989 16.7306V15.261H2.72928C2.61381 15.261 2.51934 15.1665 2.51934 15.0511V13.7914Z"
      fill="#1F3D7B"
    />
  </svg>
);

export const ShareIcon = ({ className }: SvgProps) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M13.9465 0.0946604L0.365956 7.92948C-0.164375 8.2342 -0.0969846 8.97256 0.430416 9.19524L3.54501 10.502L11.9629 3.08326C12.1241 2.93969 12.3526 3.15944 12.2149 3.32645L5.15651 11.926V14.2847C5.15651 14.9761 5.99156 15.2486 6.40176 14.7476L8.26231 12.4827L11.9131 14.0122C12.3292 14.188 12.8038 13.9272 12.88 13.4789L14.9896 0.821301C15.0892 0.22944 14.4534 -0.19834 13.9465 0.0946604Z"
      fill="#1F3D7B"
    />
  </svg>
);

export const ProfileEmailIcon = ({ className }: SvgProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect width="24" height="24" rx="2" fill="#A74C7C" />
    <path
      d="M17.7727 9.97188C17.8641 9.89922 18 9.96719 18 10.082V14.875C18 15.4961 17.4961 16 16.875 16H7.125C6.50391 16 6 15.4961 6 14.875V10.0844C6 9.96719 6.13359 9.90156 6.22734 9.97422C6.75234 10.382 7.44844 10.9 9.83906 12.6367C10.3336 12.9977 11.168 13.757 12 13.7523C12.8367 13.7594 13.6875 12.9836 14.1633 12.6367C16.5539 10.9 17.2477 10.3797 17.7727 9.97188ZM12 13C12.5437 13.0094 13.3266 12.3156 13.7203 12.0297C16.8305 9.77266 17.0672 9.57578 17.7844 9.01328C17.9203 8.90781 18 8.74375 18 8.57031V8.125C18 7.50391 17.4961 7 16.875 7H7.125C6.50391 7 6 7.50391 6 8.125V8.57031C6 8.74375 6.07969 8.90547 6.21562 9.01328C6.93281 9.57344 7.16953 9.77266 10.2797 12.0297C10.6734 12.3156 11.4563 13.0094 12 13Z"
      fill="white"
    />
  </svg>
);

export const ProfileMobileIcon = ({ className }: SvgProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect width="24" height="24" rx="2" fill="#A74C7C" />
    <path
      d="M15.3438 5H9.65625C8.98594 5 8.4375 5.54844 8.4375 6.21875V16.7812C8.4375 17.4516 8.98594 18 9.65625 18H15.3438C16.0141 18 16.5625 17.4516 16.5625 16.7812V6.21875C16.5625 5.54844 16.0141 5 15.3438 5ZM12.5 17.1875C12.0507 17.1875 11.6875 16.8243 11.6875 16.375C11.6875 15.9257 12.0507 15.5625 12.5 15.5625C12.9493 15.5625 13.3125 15.9257 13.3125 16.375C13.3125 16.8243 12.9493 17.1875 12.5 17.1875ZM15.75 14.75H9.25V6.625H15.75V14.75Z"
      fill="white"
    />
  </svg>
);

export const ProfileTelePhoneIcon = ({ className }: SvgProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect width="24" height="24" rx="2" fill="#A74C7C" />
    <path
      d="M14.975 17.0835C13.1037 17.081 11.3098 16.3366 9.98664 15.0135C8.66347 13.6903 7.91905 11.8964 7.91663 10.0251C7.91663 9.46597 8.13875 8.92971 8.53414 8.53432C8.92953 8.13893 9.46579 7.9168 10.025 7.9168C10.1434 7.9159 10.2616 7.92664 10.3779 7.94888C10.4903 7.96552 10.6008 7.99315 10.7079 8.03138C10.7832 8.0578 10.8502 8.1034 10.9025 8.16369C10.9547 8.22398 10.9903 8.29686 11.0058 8.37513L11.6337 11.1251C11.6506 11.1998 11.6486 11.2775 11.6278 11.3511C11.607 11.4248 11.568 11.4921 11.5145 11.5468C11.455 11.611 11.4504 11.6156 10.8866 11.9089C11.3381 12.8993 12.1302 13.6946 13.1187 14.1501C13.4166 13.5818 13.4212 13.5772 13.4854 13.5176C13.5401 13.4641 13.6074 13.4252 13.681 13.4044C13.7547 13.3836 13.8324 13.3815 13.907 13.3985L16.657 14.0264C16.7328 14.044 16.8029 14.0805 16.8606 14.1327C16.9183 14.1848 16.9618 14.2507 16.987 14.3243C17.0257 14.4331 17.0549 14.545 17.0741 14.6589C17.0926 14.7741 17.1018 14.8906 17.1016 15.0072C17.0932 15.564 16.8648 16.0948 16.4664 16.4838C16.0679 16.8728 15.5318 17.0884 14.975 17.0835Z"
      fill="white"
    />
  </svg>
);

export const ProfileLocationIcon = ({ className }: SvgProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect width="24" height="24" rx="2" fill="#A74C7C" />
    <path
      d="M11.7011 17.7781C8.57943 13.2526 8 12.7882 8 11.125C8 8.84682 9.84682 7 12.125 7C14.4032 7 16.25 8.84682 16.25 11.125C16.25 12.7882 15.6706 13.2526 12.5489 17.7781C12.3441 18.074 11.9059 18.074 11.7011 17.7781ZM12.125 12.8437C13.0742 12.8437 13.8437 12.0742 13.8437 11.125C13.8437 10.1758 13.0742 9.40625 12.125 9.40625C11.1758 9.40625 10.4062 10.1758 10.4062 11.125C10.4062 12.0742 11.1758 12.8437 12.125 12.8437Z"
      fill="white"
    />
  </svg>
);

export const EmptyCartIcon = ({ className }: SvgProps) => (
  <svg
    fill="#173d7b"
    height="800px"
    width="800px"
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 231.523 231.523"
    className={className}
  >
    <g>
      <path
        d="M107.415,145.798c0.399,3.858,3.656,6.73,7.451,6.73c0.258,0,0.518-0.013,0.78-0.04c4.12-0.426,7.115-4.111,6.689-8.231
		l-3.459-33.468c-0.426-4.12-4.113-7.111-8.231-6.689c-4.12,0.426-7.115,4.111-6.689,8.231L107.415,145.798z"
      />
      <path
        d="M154.351,152.488c0.262,0.027,0.522,0.04,0.78,0.04c3.796,0,7.052-2.872,7.451-6.73l3.458-33.468
		c0.426-4.121-2.569-7.806-6.689-8.231c-4.123-0.421-7.806,2.57-8.232,6.689l-3.458,33.468
		C147.235,148.377,150.23,152.062,154.351,152.488z"
      />
      <path
        d="M96.278,185.088c-12.801,0-23.215,10.414-23.215,23.215c0,12.804,10.414,23.221,23.215,23.221
		c12.801,0,23.216-10.417,23.216-23.221C119.494,195.502,109.079,185.088,96.278,185.088z M96.278,216.523
		c-4.53,0-8.215-3.688-8.215-8.221c0-4.53,3.685-8.215,8.215-8.215c4.53,0,8.216,3.685,8.216,8.215
		C104.494,212.835,100.808,216.523,96.278,216.523z"
      />
      <path
        d="M173.719,185.088c-12.801,0-23.216,10.414-23.216,23.215c0,12.804,10.414,23.221,23.216,23.221
		c12.802,0,23.218-10.417,23.218-23.221C196.937,195.502,186.521,185.088,173.719,185.088z M173.719,216.523
		c-4.53,0-8.216-3.688-8.216-8.221c0-4.53,3.686-8.215,8.216-8.215c4.531,0,8.218,3.685,8.218,8.215
		C181.937,212.835,178.251,216.523,173.719,216.523z"
      />
      <path
        d="M218.58,79.08c-1.42-1.837-3.611-2.913-5.933-2.913H63.152l-6.278-24.141c-0.86-3.305-3.844-5.612-7.259-5.612H18.876
		c-4.142,0-7.5,3.358-7.5,7.5s3.358,7.5,7.5,7.5h24.94l6.227,23.946c0.031,0.134,0.066,0.267,0.104,0.398l23.157,89.046
		c0.86,3.305,3.844,5.612,7.259,5.612h108.874c3.415,0,6.399-2.307,7.259-5.612l23.21-89.25C220.49,83.309,220,80.918,218.58,79.08z
		 M183.638,165.418H86.362l-19.309-74.25h135.895L183.638,165.418z"
      />
      <path
        d="M105.556,52.851c1.464,1.463,3.383,2.195,5.302,2.195c1.92,0,3.84-0.733,5.305-2.198c2.928-2.93,2.927-7.679-0.003-10.607
		L92.573,18.665c-2.93-2.928-7.678-2.927-10.607,0.002c-2.928,2.93-2.927,7.679,0.002,10.607L105.556,52.851z"
      />
      <path
        d="M159.174,55.045c1.92,0,3.841-0.733,5.306-2.199l23.552-23.573c2.928-2.93,2.925-7.679-0.005-10.606
		c-2.93-2.928-7.679-2.925-10.606,0.005l-23.552,23.573c-2.928,2.93-2.925,7.679,0.005,10.607
		C155.338,54.314,157.256,55.045,159.174,55.045z"
      />
      <path
        d="M135.006,48.311c0.001,0,0.001,0,0.002,0c4.141,0,7.499-3.357,7.5-7.498l0.008-33.311c0.001-4.142-3.356-7.501-7.498-7.502
		c-0.001,0-0.001,0-0.001,0c-4.142,0-7.5,3.357-7.501,7.498l-0.008,33.311C127.507,44.951,130.864,48.31,135.006,48.311z"
      />
    </g>
  </svg>
);

export const RightArrowIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="p-icon"
    aria-hidden="true"
  >
    <path
      d="M5.25 11.1728C5.14929 11.1694 5.05033 11.1455 4.9592 11.1025C4.86806 11.0595 4.78666 10.9984 4.72 
10.9228C4.57955 10.7822 4.50066 10.5916 4.50066 10.3928C4.50066 10.1941 4.57955 10.0035 4.72 9.86283L7.72 
6.86283L4.72 3.86283C4.66067 3.71882 4.64765 3.55991 4.68275 3.40816C4.71785 3.25642 4.79932 3.11936 4.91585 
3.01602C5.03238 2.91268 5.17819 2.84819 5.33305 2.83149C5.4879 2.81479 5.64411 2.84671 5.78 2.92283L9.28 
6.42283C9.42045 6.56346 9.49934 6.75408 9.49934 6.95283C9.49934 7.15158 9.42045 7.34221 9.28 7.48283L5.78 
10.9228C5.71333 10.9984 5.63193 11.0595 5.5408 11.1025C5.44966 11.1455 5.35071 11.1694 5.25 11.1728Z"
      fill="currentColor"
    ></path>
  </svg>
);

export const DoubleRightArrow = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="p-icon"
    aria-hidden="true"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.68757 11.1451C7.7791 11.1831 7.8773 11.2024 7.9764 11.2019C8.07769 11.1985 8.17721 11.1745 
      8.26886 11.1312C8.36052 11.088 8.44238 11.0265 8.50943 10.9505L12.0294 7.49085C12.1707 7.34942 12.25 
      7.15771 12.25 6.95782C12.25 6.75794 12.1707 6.56622 12.0294 6.42479L8.50943 2.90479C8.37014 2.82159 
      8.20774 2.78551 8.04633 2.80192C7.88491 2.81833 7.73309 2.88635 7.6134 2.99588C7.4937 3.10541 7.41252 
      3.25061 7.38189 3.40994C7.35126 3.56927 7.37282 3.73423 7.44337 3.88033L10.4605 6.89748L7.44337 9.91463C7.30212 
      10.0561 7.22278 10.2478 7.22278 10.4477C7.22278 10.6475 7.30212 10.8393 7.44337 10.9807C7.51301 11.0512 7.59603 11.1071 
      7.68757 11.1451ZM1.94207 10.9505C2.07037 11.0968 2.25089 11.1871 2.44493 11.2019C2.63898 11.1871 2.81949 11.0968 2.94779 
      10.9505L6.46779 7.49085C6.60905 7.34942 6.68839 7.15771 6.68839 6.95782C6.68839 6.75793 6.60905 6.56622 6.46779 6.42479L2.94779 
      2.90479C2.80704 2.83757 2.6489 2.81563 2.49517 2.84201C2.34143 2.86839 2.19965 2.94178 2.08936 3.05207C1.97906 3.16237 1.90567 
      3.30415 1.8793 3.45788C1.85292 3.61162 1.87485 3.76975 1.94207 3.9105L4.95922 6.92765L1.94207 9.9448C1.81838 10.0831 1.75 10.2621 
      1.75 10.4477C1.75 10.6332 1.81838 10.8122 1.94207 10.9505Z"
      fill="currentColor"
    ></path>
  </svg>
);

export const LeftArrow = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="p-icon"
    aria-hidden="true"
  >
    <path
      d="M8.75 11.185C8.65146 11.1854 8.55381 11.1662 8.4628 11.1284C8.37179 11.0906 8.28924 11.0351 8.22 
      10.965L4.72 7.46496C4.57955 7.32433 4.50066 7.13371 4.50066 
      6.93496C4.50066 6.73621 4.57955 6.54558 4.72 6.40496L8.22 2.93496C8.36095 
      2.84357 8.52851 2.80215 8.69582 2.81733C8.86312 2.83252 9.02048 2.90344 
      9.14268 3.01872C9.26487 3.134 9.34483 3.28696 9.36973 3.4531C9.39463 
      3.61924 9.36303 3.78892 9.28 3.93496L6.28 6.93496L9.28 9.93496C9.42045 10.0756 9.49934 
      10.2662 9.49934 10.465C9.49934 10.6637 9.42045 10.8543 9.28 10.995C9.13526 11.1257 8.9448 11.1939 8.75 11.185Z"
      fill="currentColor"
    ></path>
  </svg>
);

export const DoubleLeftArrow = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="p-icon"
    aria-hidden="true"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.71602 11.164C5.80782 11.2021 5.9063 11.2215 6.00569 11.221C6.20216 11.2301 6.39427 11.1612 6.54025 
      11.0294C6.68191 10.8875 6.76148 10.6953 6.76148 10.4948C6.76148 10.2943 6.68191 10.1021 6.54025 9.96024L3.51441 
      6.9344L6.54025 3.90855C6.624 3.76126 6.65587 3.59011 6.63076 3.42254C6.60564 3.25498 6.525 3.10069 6.40175 2.98442C6.2785 
      2.86815 6.11978 2.79662 5.95104 2.7813C5.78229 2.76598 5.61329 2.80776 5.47112 2.89994L1.97123 6.39983C1.82957 6.54167 1.75 
      6.73393 1.75 6.9344C1.75 7.13486 1.82957 7.32712 1.97123 7.46896L5.47112 10.9991C5.54096 11.0698 5.62422 11.1259 5.71602 11.164ZM11.0488 
      10.9689C11.1775 11.1156 11.3585 11.2061 11.5531 11.221C11.7477 11.2061 11.9288 11.1156 12.0574 10.9689C12.1815 10.8302 12.25 
      10.6506 12.25 10.4645C12.25 10.2785 12.1815 10.0989 12.0574 9.96024L9.03158 6.93439L12.0574 3.90855C12.1248 3.76739 12.1468 3.60881 
      12.1204 3.45463C12.0939 3.30045 12.0203 3.15826 11.9097 3.04765C11.7991 2.93703 11.6569 2.86343 11.5027 2.83698C11.3486 2.81053 11.19 
      2.83252 11.0488 2.89994L7.51865 6.36957C7.37699 6.51141 7.29742 6.70367 7.29742 6.90414C7.29742 7.1046 7.37699 7.29686 
      7.51865 7.4387L11.0488 10.9689Z"
      fill="currentColor"
    ></path>
  </svg>
);

export const PickListLoader = () => {
  return (
    <svg
      aria-hidden="true"
      className="inline w-4 h-4 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
      viewBox="0 0 100 101"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 
        50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 
        50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 
        27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
        fill="currentColor"
      />
      <path
        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 
        92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 
        4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 
        1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 
        9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 
        25.841C84.9175 28.9121 86.7997 32.2913 88.1811 
        35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
        fill="currentFill"
      />
    </svg>
  );
};
export const AlertIcon = ({ className }: SvgProps) => (
  <svg
    width="16"
    height="16"
    className={className}
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 7.69753C0 3.4463 3.4463 0 7.69753 0C11.9488 0 15.3951 3.4463 
      15.3951 7.69753C15.3951 11.9488 11.9488 15.3951 7.69753 15.3951C3.4463 15.3951 0 
      11.9488 0 7.69753ZM8.46728 3.46389C8.46728 3.03875 8.12267 2.69414 7.69753 2.69414C7.2724 
      2.69414 6.92778 3.03875 6.92778 3.46389V8.85216C6.92778 9.2773 7.2724 9.62191 7.69753 9.62191C8.12267 
      9.62191 8.46728 9.2773 8.46728 8.85216V3.46389ZM7.69753 11.1614C8.12267 11.1614 8.46728 11.506 8.46728 11.9312C8.46728 
      12.3563 8.12267 12.7009 7.69753 12.7009C7.2724 12.7009 6.92778 12.3563 6.92778 11.9312C6.92778 11.506 7.2724 11.1614 7.69753 11.1614Z"
      // fill="#FBF4F8"
    />
  </svg>
);

export const WalletIcon = ({ className }: SvgProps) => (
  <svg
    width="22"
    height="19"
    viewBox="0 0 22 19"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M20.8668 13.8379C20.6028 16.7748 18.4798 18.6998 15.3998 18.6998H5.49994C2.46398 18.6998 0 16.2358 0 13.1999V5.49994C0 2.50797 1.80398 0.417996 4.60895 0.0659993C4.89495 0.0219997 5.19195 0 5.49994 0H15.3998C15.6858 0 15.9608 0.0109998 16.2248 0.0549994C18.8538 0.362996 20.6358 2.19998 20.8668 4.86195C20.8998 5.18095 20.6358 5.44494 20.3168 5.44494H18.6118C17.5558 5.44494 16.5768 5.85194 15.8728 6.57793C15.0368 7.39192 14.6189 8.53591 14.7179 9.6799C14.8939 11.6819 16.6538 13.2549 18.7438 13.2549H20.3168C20.6358 13.2549 20.8998 13.5189 20.8668 13.8379Z" />
    <path d="M22 8.21621V10.4822C22 11.0872 21.516 11.5822 20.9 11.6042H18.744C17.5561 11.6042 16.4671 10.7352 16.3681 9.54719C16.3021 8.8542 16.5661 8.20521 17.0281 7.75421C17.4351 7.33621 17.9961 7.09424 18.612 7.09424H20.9C21.516 7.11624 22 7.61121 22 8.21621Z" />
  </svg>
);

export const ArchiveTokenIcon = ({ className }: SvgProps) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path
        d="M9 12C9 11.5341 9 11.3011 9.07612 11.1173C9.17761 10.8723 9.37229 10.6776 9.61732 10.5761C9.80109 10.5 10.0341 10.5 10.5 10.5H13.5C13.9659 10.5 14.1989 10.5 14.3827 10.5761C14.6277 10.6776 14.8224 10.8723 14.9239 11.1173C15 11.3011 15 11.5341 15 12C15 12.4659 15 12.6989 14.9239 12.8827C14.8224 13.1277 14.6277 13.3224 14.3827 13.4239C14.1989 13.5 13.9659 13.5 13.5 13.5H10.5C10.0341 13.5 9.80109 13.5 9.61732 13.4239C9.37229 13.3224 9.17761 13.1277 9.07612 12.8827C9 12.6989 9 12.4659 9 12Z"
        stroke="#FFFFFF"
        strokeWidth="1.5"
      ></path>
      <path
        d="M20.5 7V13C20.5 16.7712 20.5 18.6569 19.3284 19.8284C18.1569 21 16.2712 21 12.5 21H11.5M3.5 7V13C3.5 16.7712 3.5 18.6569 4.67157 19.8284C5.37634 20.5332 6.3395 20.814 7.81608 20.9259"
        stroke="#FFFFFF"
        strokeWidth="1.5"
        strokeLinecap="round"
      ></path>
      <path
        d="M12 3H4C3.05719 3 2.58579 3 2.29289 3.29289C2 3.58579 2 4.05719 2 5C2 5.94281 2 6.41421 2.29289 6.70711C2.58579 7 3.05719 7 4 7H20C20.9428 7 21.4142 7 21.7071 6.70711C22 6.41421 22 5.94281 22 5C22 4.05719 22 3.58579 21.7071 3.29289C21.4142 3 20.9428 3 20 3H16"
        stroke="#FFFFFF"
        strokeWidth="1.5"
        strokeLinecap="round"
      ></path>
    </g>
  </svg>
);

export const DeactivateIcon = () => (
  <svg
    width="21"
    height="16"
    viewBox="0 0 21 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.2159 7.50088L20.702 6.07571C20.9074 5.87881 20.9074 5.56003 20.702 5.36313L19.959 4.65055C19.7536 4.45365 19.4212 4.45365 19.2159 4.65055L17.7297 6.07571L16.2435 4.65055C16.0382 4.45365 15.7058 4.45365 15.5005 4.65055L14.7574 5.36313C14.552 5.56003 14.552 5.87881 14.7574 6.07571L16.2435 7.50088L14.7574 8.92605C14.552 9.12294 14.552 9.44173 14.7574 9.63863L15.5005 10.3512C15.7058 10.5481 16.0382 10.5481 16.2435 10.3512L17.7297 8.92605L19.2159 10.3512C19.4212 10.5481 19.7536 10.5481 19.959 10.3512L20.702 9.63863C20.9074 9.44173 20.9074 9.12294 20.702 8.92605L19.2159 7.50088ZM7.30047 8.00094C9.60468 8.00094 11.4722 6.2101 11.4722 4.00047C11.4722 1.79084 9.60468 0 7.30047 0C4.99626 0 3.12877 1.79084 3.12877 4.00047C3.12877 6.2101 4.99626 8.00094 7.30047 8.00094ZM10.2207 9.00106H9.67638C8.95285 9.31984 8.14784 9.50111 7.30047 9.50111C6.45309 9.50111 5.65134 9.31984 4.92456 9.00106H4.38028C1.962 9.00106 0 10.8825 0 13.2015V14.5017C0 15.3299 0.700714 16.0019 1.56439 16.0019H13.0365C13.9002 16.0019 14.6009 15.3299 14.6009 14.5017V13.2015C14.6009 10.8825 12.6389 9.00106 10.2207 9.00106Z"
      fill="#9A1A1E"
    />
  </svg>
);

export const QRicon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 6H6V0H0V6ZM2 2H4V4H2V2ZM8 0V6H14V0H8ZM12 4H10V2H12V4ZM0 14H6V8H0V14ZM2 10H4V12H2V10ZM13 8H14V12H11V11H10V14H8V8H11V9H13V8ZM13 13H14V14H13V13ZM11 13H12V14H11V13Z"
      fill="#7D395D"
    />
  </svg>
);

export const LoaderLogo = () => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 1449 1439"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <clipPath id="mvrLogoClipPath">
        <rect
          className="clipping-rect"
          x="0"
          y="0"
          width="100%"
          height="100%"
        />
      </clipPath>
    </defs>
    <path
      d="M266.334 1362.47L13.244 790.037C-29.4573 696.806 43.1276 598.665 138.172 621.511L551.899 691.491C619.563 707.63 682.43 661.074 688.745 590.005L750.762 105.042C760.169 -3.57168 890.674 -37.8038 958.365 50.3119L1420.32 610.021C1492.41 704.101 1417.29 833.379 1307.78 803.742L1202.89 775.359C1141.33 758.714 1081.37 794.622 1066.08 857.17L1006.8 1097.99C992.268 1157.35 937.182 1193.11 878.178 1181.57L634.473 1134.14C570.564 1121.74 512.182 1165.03 503.413 1231.2L489.288 1338.86C473.363 1458.9 317.978 1474.97 266.334 1362.47Z"
      fill="#1f3d7b"
    />
    <path
      className="animated-path"
      d="M266.334 1362.47L13.244 790.037C-29.4573 696.806 43.1276 598.665 138.172 621.511L551.899 691.491C619.563 707.63 682.43 661.074 688.745 590.005L750.762 105.042C760.169 -3.57168 890.674 -37.8038 958.365 50.3119L1420.32 610.021C1492.41 704.101 1417.29 833.379 1307.78 803.742L1202.89 775.359C1141.33 758.714 1081.37 794.622 1066.08 857.17L1006.8 1097.99C992.268 1157.35 937.182 1193.11 878.178 1181.57L634.473 1134.14C570.564 1121.74 512.182 1165.03 503.413 1231.2L489.288 1338.86C473.363 1458.9 317.978 1474.97 266.334 1362.47Z"
    />
  </svg>
);

export const MobileSaveIcon = ({ className }: SvgProps) => (
  <svg
    viewBox="0 -0.5 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {' '}
      <path
        d="M5.5 12.5L10.167 17L19.5 8"
        stroke="#fff"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>{' '}
    </g>
  </svg>
);

export const MobileCancelIcon = ({ className }: SvgProps) => (
  <svg
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    fill="#000000"
    className={className}
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {' '}
      <defs>
        {' '}
        <style></style>{' '}
      </defs>{' '}
      <title></title>{' '}
      <g id="cross">
        {' '}
        <line
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          x1="7"
          x2="25"
          y1="7"
          y2="25"
        ></line>{' '}
        <line
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          x1="7"
          x2="25"
          y1="25"
          y2="7"
        ></line>{' '}
      </g>{' '}
    </g>
  </svg>
);

export const InfoIcon = ({ className }: SvgProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect width="64" height="64" rx="16" fill="" />
    <path
      d="M26.5625 45.1429H28.125V33.8571H26.5625C25.6995 33.8571 25 33.1576 25 32.2946V28.5625C25 27.6995 25.6995 27 26.5625 27H35.3125C36.1755 27 36.875 27.6995 36.875 28.5625V45.1429H38.4375C39.3005 45.1429 40 45.8424 40 46.7054V50.4375C40 51.3005 39.3005 52 38.4375 52H26.5625C25.6995 52 25 51.3005 25 50.4375V46.7054C25 45.8424 25.6995 45.1429 26.5625 45.1429ZM32.5 12C29.3934 12 26.875 14.5184 26.875 17.625C26.875 20.7316 29.3934 23.25 32.5 23.25C35.6066 23.25 38.125 20.7316 38.125 17.625C38.125 14.5184 35.6066 12 32.5 12Z"
      fill="#FBF4F8"
    />
  </svg>
);

export const SupportIcon = ({ className }: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    className={className}
  >
    <path
      d="M192 208c0-17.7-14.3-32-32-32h-16c-35.4 0-64 28.7-64 64v48c0 35.4 28.7 64 64 64h16c17.7 0 32-14.3 32-32V208zm176 144c35.4 0 64-28.7 64-64v-48c0-35.4-28.7-64-64-64h-16c-17.7 0-32 14.3-32 32v112c0 17.7 14.3 32 32 32h16zM256 0C113.2 0 4.6 118.8 0 256v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-114.7 93.3-208 208-208s208 93.3 208 208h-.1c.1 2.4 .1 165.7 .1 165.7 0 23.4-18.9 42.3-42.3 42.3H320c0-26.5-21.5-48-48-48h-32c-26.5 0-48 21.5-48 48s21.5 48 48 48h181.7c49.9 0 90.3-40.4 90.3-90.3V256C507.4 118.8 398.8 0 256 0z"
      fill="#F6DFEB"
    />
  </svg>
);

export const EditIcon = ({ className }: SvgProps) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="#000000"
    strokeWidth="0.9600000000000002"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {' '}
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20.8477 1.87868C19.6761 0.707109 17.7766 0.707105 16.605 1.87868L2.44744 16.0363C2.02864 16.4551 1.74317 16.9885 1.62702 17.5692L1.03995 20.5046C0.760062 21.904 1.9939 23.1379 3.39334 22.858L6.32868 22.2709C6.90945 22.1548 7.44285 21.8693 7.86165 21.4505L22.0192 7.29289C23.1908 6.12132 23.1908 4.22183 22.0192 3.05025L20.8477 1.87868ZM18.0192 3.29289C18.4098 2.90237 19.0429 2.90237 19.4335 3.29289L20.605 4.46447C20.9956 4.85499 20.9956 5.48815 20.605 5.87868L17.9334 8.55027L15.3477 5.96448L18.0192 3.29289ZM13.9334 7.3787L3.86165 17.4505C3.72205 17.5901 3.6269 17.7679 3.58818 17.9615L3.00111 20.8968L5.93645 20.3097C6.13004 20.271 6.30784 20.1759 6.44744 20.0363L16.5192 9.96448L13.9334 7.3787Z"
        fill="#A74C7C"
      ></path>{' '}
    </g>
  </svg>
);
export const LensIcon = ({ className }: SvgProps) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {' '}
      <path
        d="M19.9604 11.4802C19.9604 13.8094 19.0227 15.9176 17.5019 17.4512C16.9332 18.0247 16.2834 18.5173 15.5716 18.9102C14.3594 19.5793 12.9658 19.9604 11.4802 19.9604C6.79672 19.9604 3 16.1637 3 11.4802C3 6.79672 6.79672 3 11.4802 3C16.1637 3 19.9604 6.79672 19.9604 11.4802Z"
        stroke="#1f3d7b"
        strokeWidth="2"
      ></path>{' '}
      <path
        d="M18.1553 18.1553L21.8871 21.8871"
        stroke="#1f3d7b"
        strokeWidth="2"
        strokeLinecap="round"
      ></path>{' '}
    </g>
  </svg>
);

export const MedicationPrescribeIcon = ({ className }: SvgProps) => (
  <svg
    width="24"
    height="33"
    viewBox="0 0 24 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M22.5 0.5H1.5C0.675 0.5 0 1.175 0 2V5C0 5.825 0.675 6.5 1.5 6.5H22.5C23.325 6.5 24 5.825 24 5V2C24 1.175 23.325 0.5 22.5 0.5ZM2 30.5C2 31.6 2.9 32.5 4 32.5H20C21.1 32.5 22 31.6 22 30.5V8.5H2V30.5ZM6 19C6 18.725 6.225 18.5 6.5 18.5H10V15C10 14.725 10.225 14.5 10.5 14.5H13.5C13.775 14.5 14 14.725 14 15V18.5H17.5C17.775 18.5 18 18.725 18 19V22C18 22.275 17.775 22.5 17.5 22.5H14V26C14 26.275 13.775 26.5 13.5 26.5H10.5C10.225 26.5 10 26.275 10 26V22.5H6.5C6.225 22.5 6 22.275 6 22V19Z"
      fill="#1F3D7B"
    />
  </svg>
);

export const DosageDiaryIcon = ({ className }: SvgProps) => (
  <svg
    width="23"
    height="33"
    viewBox="0 0 23 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M19.4076 0.500137H0.95166V32.5H19.4076C20.1536 32.4997 20.8689 32.2037 21.3972 31.6777C21.9256 31.1513 22.2243 30.437 22.2277 29.6914V3.30825C22.2243 2.56261 21.9256 1.84837 21.3972 1.32234C20.8689 0.795963 20.1536 0.500337 19.4076 0.5V0.500137ZM18.089 22.7983H4.50499C4.17593 22.7983 3.90937 22.5314 3.90937 22.2024C3.90937 21.8733 4.17593 21.6067 4.50499 21.6067H18.089C18.4181 21.6067 18.685 21.8733 18.685 22.2024C18.685 22.5314 18.4181 22.7983 18.089 22.7983ZM18.7384 15.3902C18.7384 15.9555 18.5137 16.4977 18.1144 16.8974C17.7147 17.2971 17.1724 17.5214 16.6072 17.5214H6.06154C5.49632 17.5214 4.95405 17.2971 4.55438 16.8974C4.15471 16.4977 3.93038 15.9554 3.93038 15.3902V8.84425C3.93038 8.27902 4.15471 7.73674 4.55438 7.33706C4.95406 6.93738 5.49634 6.71305 6.06154 6.71305H16.6072C17.1724 6.71305 17.7147 6.93739 18.1144 7.33706C18.5137 7.73675 18.7384 8.27903 18.7384 8.84425V15.3902Z"
      fill="#1F3D7B"
    />
  </svg>
);

export const MonthlyLimitIcon = ({ className }: SvgProps) => (
  <svg
    width="29"
    height="33"
    viewBox="0 0 29 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M0.64502 29.3398C0.64502 30.9961 1.98877 32.3398 3.64502 32.3398H25.645C27.3013 32.3398 28.645 30.9961 28.645 29.3398V12.3398H0.64502V29.3398ZM20.645 17.0898C20.645 16.6773 20.9825 16.3398 21.395 16.3398H23.895C24.3075 16.3398 24.645 16.6773 24.645 17.0898V19.5898C24.645 20.0023 24.3075 20.3398 23.895 20.3398H21.395C20.9825 20.3398 20.645 20.0023 20.645 19.5898V17.0898ZM20.645 25.0898C20.645 24.6773 20.9825 24.3398 21.395 24.3398H23.895C24.3075 24.3398 24.645 24.6773 24.645 25.0898V27.5898C24.645 28.0023 24.3075 28.3398 23.895 28.3398H21.395C20.9825 28.3398 20.645 28.0023 20.645 27.5898V25.0898ZM12.645 17.0898C12.645 16.6773 12.9825 16.3398 13.395 16.3398H15.895C16.3075 16.3398 16.645 16.6773 16.645 17.0898V19.5898C16.645 20.0023 16.3075 20.3398 15.895 20.3398H13.395C12.9825 20.3398 12.645 20.0023 12.645 19.5898V17.0898ZM12.645 25.0898C12.645 24.6773 12.9825 24.3398 13.395 24.3398H15.895C16.3075 24.3398 16.645 24.6773 16.645 25.0898V27.5898C16.645 28.0023 16.3075 28.3398 15.895 28.3398H13.395C12.9825 28.3398 12.645 28.0023 12.645 27.5898V25.0898ZM4.64502 17.0898C4.64502 16.6773 4.98252 16.3398 5.39502 16.3398H7.89502C8.30752 16.3398 8.64502 16.6773 8.64502 17.0898V19.5898C8.64502 20.0023 8.30752 20.3398 7.89502 20.3398H5.39502C4.98252 20.3398 4.64502 20.0023 4.64502 19.5898V17.0898ZM4.64502 25.0898C4.64502 24.6773 4.98252 24.3398 5.39502 24.3398H7.89502C8.30752 24.3398 8.64502 24.6773 8.64502 25.0898V27.5898C8.64502 28.0023 8.30752 28.3398 7.89502 28.3398H5.39502C4.98252 28.3398 4.64502 28.0023 4.64502 27.5898V25.0898ZM25.645 4.33984H22.645V1.33984C22.645 0.789844 22.195 0.339844 21.645 0.339844H19.645C19.095 0.339844 18.645 0.789844 18.645 1.33984V4.33984H10.645V1.33984C10.645 0.789844 10.195 0.339844 9.64502 0.339844H7.64502C7.09502 0.339844 6.64502 0.789844 6.64502 1.33984V4.33984H3.64502C1.98877 4.33984 0.64502 5.68359 0.64502 7.33984V10.3398H28.645V7.33984C28.645 5.68359 27.3013 4.33984 25.645 4.33984Z"
      fill="#1F3D7B"
    />
  </svg>
);

export const OrderHistoryIcon = ({ className }: SvgProps) => (
  <svg
    width="27"
    height="33"
    viewBox="0 0 27 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.57093 1.44251C0.468262 2.54515 0.468262 4.31985 0.468262 7.86926V24.8104C0.468262 28.3598 0.468262 30.1345 1.57093 31.2372C2.67357 32.3398 4.44827 32.3398 7.99767 32.3398H19.2918C22.8412 32.3398 24.6158 32.3398 25.7185 31.2372C26.8212 30.1345 26.8212 28.3598 26.8212 24.8104V7.86926C26.8212 4.31985 26.8212 2.54515 25.7185 1.44251C24.6158 0.339844 22.8412 0.339844 19.2918 0.339844H7.99767C4.44827 0.339844 2.67357 0.339844 1.57093 1.44251ZM7.99767 7.86926C6.95809 7.86926 6.11532 8.71202 6.11532 9.75161C6.11532 10.7912 6.95809 11.634 7.99767 11.634H19.2918C20.3314 11.634 21.1741 10.7912 21.1741 9.75161C21.1741 8.71202 20.3314 7.86926 19.2918 7.86926H7.99767ZM7.99767 15.3987C6.95809 15.3987 6.11532 16.2414 6.11532 17.281C6.11532 18.3206 6.95809 19.1634 7.99767 19.1634H19.2918C20.3314 19.1634 21.1741 18.3206 21.1741 17.281C21.1741 16.2414 20.3314 15.3987 19.2918 15.3987H7.99767ZM7.99767 22.9281C6.95809 22.9281 6.11532 23.7708 6.11532 24.8104C6.11532 25.8501 6.95809 26.6928 7.99767 26.6928H15.5271C16.5667 26.6928 17.4094 25.8501 17.4094 24.8104C17.4094 23.7708 16.5667 22.9281 15.5271 22.9281H7.99767Z"
      fill="#1F3D7B"
    />
  </svg>
);

export const ArrowRightIcon = ({ className }: SvgProps) => (
  <svg
    width="21"
    height="18"
    viewBox="0 0 21 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M20.0681 8.39961L12.3056 0.524609C11.9681 0.187109 11.4431 0.187109 11.1056 0.524609C10.7681 0.862109 10.7681 1.38711 11.1056 1.72461L17.4056 8.13711H1.46807C1.01807 8.13711 0.643066 8.51211 0.643066 8.96211C0.643066 9.41211 1.01807 9.82461 1.46807 9.82461H17.4806L11.1056 16.3121C10.7681 16.6496 10.7681 17.1746 11.1056 17.5121C11.2556 17.6621 11.4806 17.7371 11.7056 17.7371C11.9306 17.7371 12.1556 17.6621 12.3056 17.4746L20.0681 9.59961C20.4056 9.26211 20.4056 8.73711 20.0681 8.39961Z"
      fill="#1F3D7B"
    />
  </svg>
);

export const ArrowDownIcon = ({ className }: SvgProps) => (
  <svg
    width="15"
    height="12"
    viewBox="0 0 15 12"
    fill=""
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M1.00705 0.5H13.9597C14.8557 0.5 15.3038 1.90231 14.6695 2.72413L8.19568 11.1184C7.80303 11.6272 7.1637 11.6272 6.77105 11.1184L0.297251 2.72413C-0.33704 1.90231 0.110991 0.5 1.00705 0.5Z" />
  </svg>
);

export const BackToTopIcon = ({ className }: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="30"
    height="30"
    fill="none"
    className={className}
  >
    <path d="M12 5l-7 7h4v7h6v-7h4l-7-7z" fill="#ffffff" />
  </svg>
);

export const ArrowLeftIcon = ({ className }: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 26 26"
    width="30"
    height="30"
    fill="none"
    className={className}
  >
    <path
      d="M14.7 5.3a1 1 0 0 1 0 1.4L10.41 11H20a1 1 0 1 1 0 2h-9.59l4.3 4.3a1 1 0 1 1-1.42 1.4l-6-6a1 1 0 0 1 0-1.4l6-6a1 1 0 0 1 1.42 0z"
      fill="#1f3d7b"
    />
  </svg>
);

export const RedAlertIcon = () => (
  <svg
    className="w-5 h-5 text-red-600"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 9v2m0 4h.01M10.29 3.86l-7.4 12.8A2 2 0 004.6 20h14.8a2 2 0 001.71-3.04l-7.4-12.8a2 2 0 00-3.42 0z"
    />
  </svg>
);
